import React, { useState } from 'react';
import { Box, Button, Modal, Typography, Table, TableBody, TableCell, TableHead, TableRow, Paper, TableContainer } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // Pour rediriger vers la page d'édition
import { getUserProvider } from '../../../../actions/auth.js'; // Pour obtenir le provider de l'utilisateur
import { usePermissions } from '../../../../permissions/usePermissions.js';
import { PERMISSIONS } from '../../../../permissions/permissionKeys.js';
import useStyles from '../../../../styles/global-mui.js';
import DsasButton from '../../../components/DsasButton/DsasButton.js';
import { Can } from '../../../../permissions/Can.js';

const CompetitionCheckModal = ({ open, onClose, results, onSelectOtherCompetition, onConfirmNone, actualProvider = getUserProvider()  }) => {
  const navigate = useNavigate();

  const handleSelectMyCompetition = (competitionId) => {
    navigate(`/sports/competitions/create/${competitionId}`);
  };

  const handleSelectOtherCompetition = (competition) => {
    onSelectOtherCompetition(competition);
    onClose();
  };

    const { getPermission } = usePermissions();
    const providerPermission = getPermission(PERMISSIONS.SPORT_COMPETITION_PROVIDER_NAME_DISPLAY);

    const classes = useStyles();

  return (
     <Modal open={open} onClose={onClose}>
         <Paper
           sx={{
             width: '90%', // 90% de la largeur de l'écran
             maxWidth: '600px', // Limite de la largeur maximale
             margin: 'auto',
             marginTop: { xs: '10%', md: '5%' }, // Gérer la marge en fonction de la taille de l'écran
             maxHeight: '90vh', // Limite de la hauteur
             overflowY: 'auto', // Activer le défilement si le contenu dépasse la hauteur
             boxSizing: 'border-box',
           }}
         >
           <Box className='medium-padding'>
             {/* <Typography variant="h6" gutterBottom>Vérification des compétitions existantes</Typography> */}
             <Box className='centered-wrapper'>
               <h3 className='page-title'>Vérification des compétitions existantes</h3>
             </Box>
             
             <Box className='medium-padding'>
              {/* Vos compétitions */}
              <h5 className='page-title'>Vos compétitions</h5>

              {!results
                  .filter((competition) => competition.provider === actualProvider).length ?
                  <Typography variant="subtitle1">Aucune de vos compétitions ne correspond à la recherche</Typography>
                  :
                  (<TableContainer sx={{ maxWidth: '100%', overflowX: 'auto' }}>
                    <Table className={classes.customTable} size="small" sx={{ minWidth: '100%' }}>
                      <TableHead>
                        <TableRow>
                          <TableCell>Nom</TableCell>
                          <TableCell>Discipline</TableCell>
                          <TableCell>Saison</TableCell>
                          <TableCell>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {results
                          .filter((competition) => competition.provider === actualProvider)
                          .map((competition) => (
                            <TableRow key={competition._id}>
                              <TableCell>{competition.name}</TableCell>
                              <TableCell>{competition.discipline}</TableCell>
                              <TableCell>{competition.season}</TableCell>
                              <TableCell>
                                <Button size="small" variant="contained" onClick={() => handleSelectMyCompetition(competition._id)}>
                                  Modifier
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                </TableContainer>)
              }
            </Box>

      <Box className='medium-padding'>
        {/* Les autres compétitions */}
                  <h5 className='page-title'>Nos suggestions de compétitions</h5>
        
                  <TableContainer sx={{ maxWidth: '100%', overflowX: 'auto' }}>
                    <Table className={classes.customTable} size="small" sx={{ minWidth: '100%' }}>
            <TableHead>
              <TableRow>
                <TableCell>Nom</TableCell>
                <TableCell>Discipline</TableCell>
                 {providerPermission?.allowed &&
                    <Can permission={PERMISSIONS.SPORT_COMPETITION_PROVIDER_NAME_DISPLAY}>
                      <TableCell>Provider</TableCell>                          
                    </Can>
                  }
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {results
                .filter((competition) => competition.provider !== actualProvider)
                .map((competition) => (
                  <TableRow key={competition._id}>
                    <TableCell>{competition.name}</TableCell>
                    <TableCell>{competition.discipline}</TableCell>
                     {providerPermission?.allowed &&
                      <Can permission={PERMISSIONS.SPORT_COMPETITION_PROVIDER_NAME_DISPLAY}>
                        <TableCell>{competition.provider}</TableCell>                          
                      </Can>
                      }
                    <TableCell>
                      <Button size="small" variant="contained" onClick={() => handleSelectOtherCompetition(competition)}>
                        Utiliser
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Aucune des compétitions ne correspond */}
        <Box sx={{ textAlign: 'center', marginTop: 3 }}>
          <Table className={classes.customTable} size="small" sx={{ minWidth: '100%' }}>
            <TableBody>
              <TableRow>
                <TableCell className='no-border' sx={{ textAlign: 'center' }}>
                  <Box className='centered-wrapper' sx={{ textAlign: 'center' }} >
                  <DsasButton label="Aucune des compétitions ne correspond à ma compétition" onClick={onConfirmNone} variant = 'primary' focused={true}/>
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>

        </Box>

      </Box>
      </Paper>
    </Modal>
  );
};

export default CompetitionCheckModal;
